import { render, staticRenderFns } from "./RoleField.vue?vue&type=template&id=5103d62d&scoped=true&"
import script from "./RoleField.vue?vue&type=script&lang=js&"
export * from "./RoleField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103d62d",
  null
  
)

export default component.exports